module.exports = __webpack_public_path__ + "img/pic16.e56c13e8.jpg";